<template>
  <div class="remarks">
    <!-- Button trigger modal -->
    <div @click="dialog?.showModal()" class="d-flex gap-2 flex-wrap">
      <button v-if="stati.length" class="btn btn-sm btn-outline-light">
        <i class="icon icon-exclamation-octagon-fill"></i> Störungen
      </button>
      <button v-if="warnings.length" class="btn btn-sm btn-outline-light">
        <i class="icon icon-exclamation-triangle-fill"></i> Warnungen
      </button>
      <button v-if="hints.length" class="btn btn-sm btn-outline-light">
        <i class="icon icon-info-circle-fill"></i> Infos
      </button>
    </div>

    <!-- Modal -->
    <dialog
      ref="dialog"
      @click="closeDialog"
      class="p-0 border border-0 bg-transparent"
      closeby="any"
    >
      <div class="card shadow">
        <div class="card-body">
          <div></div>
          <form method="dialog" class="d-flex justify-content-between">
            <h5 class="card-title">Meldungen</h5>
            <button type="submit" class="btn-close" aria-label="Close"></button>
          </form>

          <div class="remarks-list">
            <div v-if="stati.length" class="d-contents">
              <i class="icon icon-exclamation-octagon-fill"></i>
              <div>
                <b>Störungen</b>
                <div class="mb-1" v-for="remark in stati" :key="remark.text">
                  {{ remark.text }}
                </div>
              </div>
            </div>

            <div v-if="warnings.length" class="d-contents">
              <i class="icon icon-exclamation-triangle-fill"></i>
              <div>
                <b>Warnungen</b>
                <div class="mb-1" v-for="remark in warnings" :key="remark.text">
                  {{ remark.text }}
                </div>
              </div>
            </div>

            <div v-if="hints.length" class="d-contents">
              <i class="icon icon-info-circle-fill"></i>
              <div>
                <b>Hinweise</b>
                <div class="mb-1" v-for="remark in hints" :key="remark.text">
                  {{ remark.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dialog>
  </div>
</template>

<script setup lang="ts">
import { type Remark } from '~/types/fptfTypes'
import { computed, useTemplateRef } from 'vue'

const props = defineProps<{
  remarks: Remark[]
}>()

const dialog = useTemplateRef('dialog')

function isInfoStatus(remark: Remark): boolean {
  return remark.summary.includes('Information.') || remark.summary.includes('Bauarbeiten.')
}

const warnings = computed(() => props.remarks.filter((r) => r.type === 'warning'))
const hints = computed(() =>
  props.remarks
    .filter((r) => r.type === 'status' && isInfoStatus(r))
    .concat(props.remarks.filter((r) => r.type === 'hint'))
)
const stati = computed(() => props.remarks.filter((r) => r.type === 'status' && !isInfoStatus(r)))

function closeDialog(e: MouseEvent) {
  if (!dialog.value) return

  const dialogDimensions = dialog.value.getBoundingClientRect()
  if (
    e.clientX < dialogDimensions.left ||
    e.clientX > dialogDimensions.right ||
    e.clientY < dialogDimensions.top ||
    e.clientY > dialogDimensions.bottom
  ) {
    dialog.value.close()
  }
}
</script>

<style lang="scss">
.remarks {
  .btn {
    @include border-radius;
  }
}

.remarks-list {
  display: grid;
  grid-template-columns: max-content auto;
  gap: 10px;
}

dialog {
  max-width: min(600px, 98%);
}

dialog::backdrop {
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
}
</style>
